// extracted by mini-css-extract-plugin
module.exports = {"confirmation":"j_m","fadeIn":"j_n"};